import {SnsService} from "./sns.service";

export const SnsInjectables: Array<any> = [
  {
    provide: SnsService,
    useClass: SnsService,
  },
];
